import { http } from "./http.js";

async function getWarehouseLoadingPlaceReference(id) {
  const response = await http.get(`warehouses/${id}/loading-place`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    country: {
      id: response.data.Country.Id,
      title: response.data.Country.Title,
    },
  };
}
async function getWarehouseContactPerson(id) {
  const response = await http.get(`warehouses/${id}/contact-persons`);
  return response.data.length ? response.data.map(r => {
    return {
      text: r.FullName,
      value: r.Id,
    };
  }) : [];
}

async function createContactPersonReference(id, contactPerson) {
  const response = await http.put(`warehouses/${id}/contact-persons`, { value: contactPerson });
  return response;
}

export { getWarehouseLoadingPlaceReference, getWarehouseContactPerson, createContactPersonReference };
